import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { RelatedReferenceComponentType } from '@appTypes/articleType';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { useTrackCTA } from '@utils/Tracking/CtaClick/TrackCtaClick';
import { mapSimbaVariant, type LegacyButtonVariant } from '@utils/simba';
import { useTrackPromotion } from '@hooks/useTrackPromotion';
import { getPromotionEventTrackingData } from '@utils/Tracking/Promotion/getPromotionEventTrackingData';

interface CtaButtonInternalLinkSerializerProps {
  value: {
    text: string;
    anchorId?: string;
    referenceComponent: RelatedReferenceComponentType;
    variant?: LegacyButtonVariant;
  };
}

export const CtaButtonInternalLink = ({
  value: { text, anchorId, referenceComponent, variant },
}: CtaButtonInternalLinkSerializerProps) => {
  const referenceUrl = useDocumentUrlWithNode(referenceComponent) || '';
  const trackCTA = useTrackCTA();

  let linkUrl = referenceUrl;
  if (anchorId) {
    linkUrl = `${referenceUrl}#${anchorId}`;
  }
  const buttonVariant = mapSimbaVariant(variant);
  const promotion = getPromotionEventTrackingData(text, linkUrl);
  const shouldTrackPromotion = Boolean(promotion);
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'internal-link',
    creative_name: `CTA | ${buttonVariant.variant} | ${text}`,
    promotion_id: promotion?.promotion_id,
    promotion_name: promotion?.promotion_name,
  });
  return (
    <div ref={shouldTrackPromotion ? wrapperRef : undefined}>
      <Button
        onClick={() => {
          if (shouldTrackPromotion) {
            trackSelectPromotion();
          }
          trackCTA({ cta_position: 'content', text, url: linkUrl });
        }}
        to={linkUrl}
        variant={buttonVariant.variant}
        color={buttonVariant.color}
        shade={buttonVariant.shade}
      >
        {text}
      </Button>
    </div>
  );
};
